import { createStore } from '@updater-core/lib/store';
import { loggerMiddleware } from '@updater-core/lib/logger';
import { log } from '@updater-core/interactors/move-items/logger';
import { DomainTracker } from '@updater-core/interactors/domain-tracker';
import { SessionInteractor } from '@updater-core/interactors/shell/session/interactor.d';
import { MoveItemsGateway } from '@updater-core/gateways/move-items';
import * as actions from './actions';
import * as selectors from './selectors';
import { MoveItemsInteractor, MoveItemsState } from './types.d';

const DEFAULT_STATE = {
  items: [],
};

export default function createInteractor({
  interactors: { stepTracker, session },
  gateways,
}: {
  interactors: {
    stepTracker: DomainTracker;
    session: SessionInteractor;
  };
  gateways: {
    moveItems: MoveItemsGateway;
  };
}): MoveItemsInteractor {
  const moveItemsGateway = gateways.moveItems;

  const declinedItems = session.selectors.declinedItems(session.getState());

  const store = createStore<MoveItemsState>(
    {
      ...DEFAULT_STATE,
      declinedItems,
    },
    [loggerMiddleware(log)]
  );

  return {
    ...store,
    actions: {
      fetchRemoteItems: actions.fetchRemoteItems({ store, moveItemsGateway }),
      fetchDeclinedItems: actions.fetchDeclinedItems({ store, session }),
      setStepStatus: actions.setStepStatus({
        store,
        moveItemsGateway,
        stepTracker,
        session,
      }),
      setItemMetadata: actions.setItemMetadata({ store, moveItemsGateway }),
    },
    selectors: {
      // itemHasStatus: selectors.itemHasStatus,
      itemMetadata: selectors.itemMetadata,
      mergedItems: selectors.mergedItems,
      status: selectors.status,
    },
  };
}
